<template>
    <!-- who a risk is screened for: the round flag of czech or slovak companies, a globe for companies abroad,
         a figure for natural persons -->
    <span class="catalogue-audience" :title="title">
        <span v-if="audience === 'cz' || audience === 'sk'" :class="['fi', 'fis', 'fi-' + audience]"></span>
        <svg v-else-if="audience === 'international'" viewBox="0 0 24 24" width="15" height="15" fill="none"
            stroke="currentColor" stroke-width="2"
        >
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M3 12h18"></path>
            <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0 -18"></path>
        </svg>
        <svg v-else viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="8" r="4"></circle>
            <path d="M4 21a8 8 0 0 1 16 0"></path>
        </svg>
    </span>
</template>

<script>
export default {
    props: {
        audience: { type: String, required: true },
        title: { type: String, default: null }
    }
};
</script>
